import {action} from "mobx";
import paymentPeriodService from "../services/paymentPeriodService";
import appStore from "./appStore";
import i18n from "../i18n";

class paymentPeriodStore {
    @action getPaymentPeriodList = async (params) => {
        const resultOfRequest = await paymentPeriodService.getPaymentPeriodList({params});
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action createPaymentPeriod = async params => {
        const resultOfRequest = await paymentPeriodService.createPaymentPeriod(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.paymentManagement.createPaymentPeriod.successMesageContent", {
                ns: "common"
            })
        });
        return true;
    };

    @action updatePaymentPeriod = async params => {
        const resultOfRequest = await paymentPeriodService.updatePaymentPeriod(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.paymentManagement.updatePaymentPeriod.successMesageContent", {
                ns: "common"
            })
        });
        return true;
    };

    @action deletePaymentPeriod = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await paymentPeriodService.deletePaymentPeriod(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };

    @action sentNotificationPaymentPeriod = async params => {
        const resultOfRequest = await paymentPeriodService.sentNotificationPaymentPeriod(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t(
                "stores.paymentManagement.sentNotificationPaymentPeriod.successMesageContent",
                {
                    ns: "common"
                }
            )
        });
        appStore.getCompanyUserList();
        return resultOfRequest.data;
    };

    @action paymentPeriodWithNames = async params => {
        const resultOfRequest = await paymentPeriodService.paymentPeriodWithNames(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action calculateAndProcess = async params => {
        const resultOfRequest = await paymentPeriodService.calculateAndProcess(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content:
                params.action === "calculate"
                    ? "Hesaplama işlemi başarıyla tamamlandı"
                    : "Aktarma işlemi başarıyla tamamlandı"
        });
        return resultOfRequest.data;
    };
}

export default new paymentPeriodStore();
